import {
    FETCH_KIOSKS,
    SAVE_KIOSK,
    DELETE_KIOSK
} from '../types';
import api from '../api';

export const fetchKiosks = (restIds) => {
    return {
        type: FETCH_KIOSKS,
        payload: api.kiosks.getAll(restIds),
    };
};

export const saveKiosk = (kiosk) => {
    if (kiosk.id) {
        return {
            type: SAVE_KIOSK,
            payload: api.kiosks.update(kiosk),
            meta: { kioskId: kiosk.id, toastSuccess: true }
        };
    } else {
        return {
            type: SAVE_KIOSK,
            payload: api.kiosks.create(kiosk),
            meta: { toastSuccess: true }
        };
    }
};

export const deleteKiosk = (kioskId) => {
    return {
        type: DELETE_KIOSK,
        payload: api.kiosks.delete(kioskId),
        meta: { kioskId, toastSuccess: true }
    };
};
